export enum PLAN_STATUS {
  DELETE = 'D',
}

export type StatusType = 'L' | 'R' | 'list' | 'request';
export type PlanTabType = 'L' | 'R';

export interface HoslogPlans {
  sno: string;
  planId: string;
  planName: string;
  planType: string;
  planTime: string;
  planCategory: string;
  planTitle: string;
  planTitleEng: string;
  description?: string;
  planPrice: number;
  price: number;
  strikePrice?: number;
  isStrikeOut?: string;
  planStatus: PLAN_STATUS;
  createdDate: number;
  updatedDate: number;
  liquor: string;
  nomination: number;
  noOfPeople: number;
}
